import React from "react";

export default function MerchandiseProductGridSkeleton() {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr className="bg-gray-50">
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Create Date</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Logo</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Brand</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Merchant</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Product Code</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Product Name</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Country</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Platform Category</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Price</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 animate-pulse">
          {Array.from({ length: 6 }).map((_, i) => (
            <tr key={i}>
              {Array.from({ length: 10 }).map((_, j) => (
                <td key={j} className="px-4 py-3">
                  <div className={
                    j === 1
                      ? "h-8 w-8 bg-gray-200 rounded-md mx-auto"
                      : "h-4 w-full bg-gray-200 rounded"
                  } />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
} 